import React from "react";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "./ui/accordion";

const faqs = [
  {
    q: "Do I need to be 'techy' to work with you?",
    a: "Not in the slightest. Most of our clients are tradespeople who would rather not look at a spreadsheet again. We handle the technical bit; you tell us what makes your customers tick.",
  },
  {
    q: "How long does it take to go live?",
    a: "Starter assistants are typically live within 7 days. Grow packages take 2–3 weeks. Scale projects are bespoke and we'll quote a clear timeline before we begin.",
  },
  {
    q: "Will it sound like a robot to my customers?",
    a: "No. We script tone, accent and vocabulary to match your brand. Many customers don't realise it isn't a human — and we always disclose it when it matters (legally and ethically).",
  },
  {
    q: "What happens if the AI gets it wrong?",
    a: "We design escape hatches. If the assistant is unsure, it captures the enquiry and sends it straight to you with a one-tap callback. You always stay in control.",
  },
  {
    q: "Can it integrate with my current tools?",
    a: "Yes — we plug into WhatsApp, Google Calendar, Outlook, Jobber, ServiceM8, HubSpot, Pipedrive, Google Sheets, Stripe, GoCardless and many more. If you can name it, we can probably wire it up.",
  },
  {
    q: "Is my customer data safe?",
    a: "Absolutely. We're GDPR-compliant, host data in the UK/EU, and only collect what's needed to do the job. We sign a Data Processing Agreement with every client.",
  },
  {
    q: "What if I want to cancel?",
    a: "After your first month, cancel anytime with 30 days' notice. We'll export your data and conversation history so you're never locked in.",
  },
];

export const Faq = () => {
  return (
    <section
      id="faq"
      data-testid="faq-section"
      className="border-b-2 border-ink py-24 lg:py-32 bg-[var(--paper)]"
    >
      <div className="max-w-4xl mx-auto px-5 lg:px-8">
        <div className="text-center">
          <p className="uppercase text-sm font-bold tracking-[0.25em] text-[var(--pink)]">
            Got questions?
          </p>
          <h2 className="font-display mt-3 text-4xl sm:text-5xl lg:text-6xl font-black tracking-tight">
            Frequently asked.
            <br />
            <span className="text-[var(--blue)]">Honestly answered.</span>
          </h2>
        </div>

        <div className="mt-12 bg-white border-2 border-ink rounded-3xl shadow-brutal divide-y-2 divide-stone-900 overflow-hidden">
          <Accordion type="single" collapsible className="w-full">
            {faqs.map((f, i) => (
              <AccordionItem
                key={f.q}
                value={`item-${i}`}
                className="border-0 border-b-2 border-stone-900 last:border-b-0"
                data-testid={`faq-item-${i}`}
              >
                <AccordionTrigger className="px-6 py-5 text-left font-display text-lg sm:text-xl font-bold hover:bg-[var(--yellow)]/30 hover:no-underline">
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="px-6 pb-5 text-stone-700 text-base leading-relaxed">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>

        <p className="text-center mt-8 text-stone-700">
          Still curious? Drop us a line at{" "}
          <a
            href="mailto:eventinfo@iariya.com"
            className="font-bold text-[var(--pink)] underline underline-offset-4"
          >
            eventinfo@iariya.com
          </a>
        </p>
      </div>
    </section>
  );
};
